export class ForgeProjectContext {
    constructor(model) {
        this.createdAt = new Date(model.createdAt);
        this.definition = model.definition;
        this.dependencies = model.dependencies;
        this.designSystemId = model.designSystemId;
        this.id = model.id;
        this.meta = model.meta;
        this.name = model.name;
        this.platform = model.platform;
        this.styling = model.styling;
        this.tailwindConfig = model.tailwindConfig;
        this.updatedAt = new Date(model.updatedAt);
        this.workspaceId = model.workspaceId;
        this.npmProxySettings = model.npmProxySettings;
    }
    toRemote() {
        return Object.assign(Object.assign({}, this), { createdAt: this.createdAt.toISOString(), updatedAt: this.updatedAt.toISOString() });
    }
}
